const formFields = {
  email: {
    value: "",
    name: "email",
    error: {
      status: false,
      message: "",
    },
    required: true,
    email: {
      validate: true,
      message: "Whoops, invalid email format.",
    },
  },
};

export default formFields;
